module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1113.b9830015.png";